module.exports = __webpack_public_path__ + "img/Logical Framework (5).ff2a7105.png";